/**
 * Represents a recording object.
 */
export class Recording {
  /**
   * The recording ID.
   */
  private rid!: string;
  /**
   * The URL of the recording.
   */
  private recording_url!: string;
  /**
   * The start time of the recording.
   */
  private startTime!: number;
  /**
   * The end time of the recording.
   */
  private endTime!: number;
  /**
   * The duration of the recording.
   */
  private duration!: number;

  /**
   * Creates a new instance of the Recording class.
   * @param data - The data to initialize the recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(data: any) {
    Object.assign(this, data);
  }

  /**
   * Gets the recording ID.
   * @returns The recording ID.
   */
  getRid(): string {
    return this.rid;
  }

  /**
   * Sets the recording ID.
   * @param value - The recording ID to set.
   */
  setRid(value: string) {
    this.rid = value;
  }

  /**
   * Gets the recording URL.
   * @returns The recording URL.
   */
  getRecordingURL(): string {
    return this.recording_url;
  }

  /**
   * Sets the recording URL.
   * @param value - The recording URL to set.
   */
  setRecordingURL(value: string) {
    this.recording_url = value;
  }

  /**
   * Gets the start time of the recording.
   * @returns The start time of the recording.
   */
  getStartTime(): number {
    return this.startTime;
  }

  /**
   * Sets the start time of the recording.
   * @param value - The start time of the recording to set.
   */
  setStartTime(value: number) {
    this.startTime = value;
  }

  /**
   * Gets the end time of the recording.
   * @returns The end time of the recording.
   */
  getEndTime(): number {
    return this.endTime;
  }

  /**
   * Sets the end time of the recording.
   * @param value - The end time of the recording to set.
   */
  setEndTime(value: number) {
    this.endTime = value;
  }

  /**
   * Gets the duration of the recording.
   * @returns The duration of the recording.
   */
  getDuration(): number {
    return this.duration;
  }

  /**
   * Sets the duration of the recording.
   * @param value - The duration of the recording to set.
   */
  setDuration(value: number) {
    this.duration = value;
  }

  /**
   * Creates a new Recording object from the given JSON data.
   * @param data - The JSON data to create the Recording object from.
   * @returns A new Recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static getRecordingFromJson(data: any): Recording {
    const recording = new Recording(data);
    return recording;
  }
}
